import { render, staticRenderFns } from "./total.vue?vue&type=template&id=66fbdfe3&scoped=true&"
import script from "./total.vue?vue&type=script&lang=js&"
export * from "./total.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fbdfe3",
  null
  
)

export default component.exports